import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import Pagination from "react-js-pagination";
import NoContent, { NO_COUPON } from "NoContent";
import {
  fetchCoupons,
  searchCoupon,
  fetchOrders,
  fetchAllTickets,
} from "TicketAction";
import { itemCount, screenHeightLeftFromTop } from "Constants";
import CouponItem from "./coupon-list-item";
import AddCoupon from "./addcoupon";
import Loader from "Loader";
import LocaleStrings from "Languages";

class Coupon extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageNumber: 1,
      search: "",
      loading: true,
      desc: LocaleStrings.preparingPromoDiscount,
    };
    this.onSearchCoupon = this.onSearchCoupon.bind(this);
  }

  componentDidMount() {
    this.props.fetchCoupons(this.props.session, 0, 0, (callback) => {
      this.setState({ loading: false });
    });
    this.props.fetchOrders(this.props.session);
    this.props.fetchAllTickets(this.props.session);
  }

  renderCouponList() {
    let pageDataLength = this.props.couponList.resource.length;
    let { pageNumber } = this.state;
    let orderList =
      this.props.orderList && this.props.orderList.totalOrder
        ? this.props.orderList.totalOrder
        : "";
    var couponCodeUsed = [];

    if (orderList && orderList.length > 0) {
      _.map(orderList, (order) => {
        if (order.couponcode != "") {
          if (typeof couponCodeUsed[order.couponcode] === "undefined") {
            couponCodeUsed[order.couponcode] = 1;
          } else {
            couponCodeUsed[order.couponcode] =
              parseInt(couponCodeUsed[order.couponcode]) + 1;
          }
        }
      });
    }

    return _.map(this.props.couponList.resource, (coupon) => {
      let used =
        typeof couponCodeUsed[coupon.couponcode] === "undefined"
          ? 0
          : couponCodeUsed[coupon.couponcode];
      return (
        <CouponItem
          key={coupon.id}
          coupon={coupon}
          couponCodeUsed={used}
          pageDataLength={pageDataLength}
          currentPage={pageNumber}
          pagination={this.paginationCallback}
        />
      );
    });
  }

  onSearchCoupon = (event) => {
    var search = event.target.value;
    let pageNumber = 1;
    if (search == "") {
      this.props.fetchCoupons(
        this.props.session,
        pageNumber,
        0,
        (callback) => {}
      );
    } else {
      this.props.searchCoupon(
        this.props.session,
        search,
        pageNumber,
        0,
        (callback) => {}
      );
    }
    this.setState({ search, pageNumber });
  };

  paginationCallback = (pageNumber) => {
    let { search } = this.state;
    if (search == "") {
      this.props.fetchCoupons(
        this.props.session,
        pageNumber,
        0,
        (callback) => {}
      );
    } else if (search != "") {
      this.props.searchCoupon(
        this.props.session,
        search,
        pageNumber,
        0,
        (callback) => {}
      );
    }
    this.setState({ ...this.state, pageNumber });
  };

  /**
   * =============================================================================================
   */

  render() {
    let { deviceSize } = this.props;
    let { desc } = this.state;
    let couponList =
      this.props.couponList && this.props.couponList.resource
        ? this.props.couponList.resource
        : "";

    return (
      <div className="panel noborder-panel">
        <div className="content-header-bar">
          <div className="vertical-align-center">
            <div className="tickets-heading">
              {LocaleStrings.tickets_coupon_text_promo_discount}
            </div>
          </div>

          <ul className="header-buttons">
            <li>
              <input
                className="form-control mapsearch"
                placeholder={LocaleStrings.button_search}
                type="text"
                value={this.state.search}
                onChange={this.onSearchCoupon}
              />
            </li>
            <li>
              <AddCoupon history={this.props.history} />
            </li>
          </ul>
        </div>

        <div
          className="panel-body scrollable-content"
          style={{ height: deviceSize.height - screenHeightLeftFromTop }}
        >
          {this.state.loading ? (
            <div className="loader-container">
              <Loader />
              <div className="loader-info">{desc}</div>
            </div>
          ) : (
            <>
              {couponList && couponList.length > 0 ? (
                <div className="sponsor-table">
                  <table className="table" border="0">
                    <thead>
                      <tr>
                        <th>{LocaleStrings.tickets_coupon_table_list_code}</th>
                        <th>
                          {LocaleStrings.tickets_coupon_table_list_discount}
                        </th>
                        <th>
                          {LocaleStrings.tickets_coupon_table_list_used_number}
                        </th>
                        <th>
                          {LocaleStrings.tickets_coupon_table_list_use_limit}
                        </th>
                        <th>
                          {LocaleStrings.tickets_coupon_table_list_status}
                        </th>
                        <th className="w-200px">
                          {LocaleStrings.tickets_coupon_table_list_action}
                        </th>
                      </tr>
                    </thead>
                    <tbody className="tbody-background">
                      {this.renderCouponList()}
                    </tbody>
                  </table>

                  {this.props.couponList &&
                  this.props.couponList.count > itemCount ? (
                    <Pagination
                      activePage={this.state.pageNumber}
                      itemsCountPerPage={itemCount}
                      totalItemsCount={this.props.couponList.count}
                      pageRangeDisplayed={10}
                      onChange={this.paginationCallback}
                      style={{ float: "right" }}
                    />
                  ) : (
                    ""
                  )}
                </div>
              ) : (
                <NoContent contentType={NO_COUPON} />
              )}
            </>
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    ticketMenus: state.ticketMenus,
    session: state.session,
    couponList: state.CouponList,
    showModal: state.showTicketModal,
    orderList: state.OrderList,
    deviceSize: state.deviceSize,
  };
}

export default connect(mapStateToProps, {
  fetchCoupons,
  searchCoupon,
  fetchOrders,
  fetchAllTickets,
})(Coupon);
